import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";

import "./styles/base.css";
import "./styles/layout.css";
import "./styles/rebuild.css";
import "./styles/experience.css";
import "./styles/print.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Missing #root element.");

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
